module.exports = __webpack_public_path__ + "static/media/channel-sample-of-certs.c05ba916.jpg";